import Button from 'components/common/Button'
import Container from 'components/common/Container'
import Heading from 'components/common/Heading'
import routes from 'routes'

const Home = () => {
  return (
    <Container className="pt-4">
        <section>
          <Heading className="mb-4">
            Checkout out solutions by task bellow:
          </Heading>

          <ul>
          {
            routes
              .filter(route => route.label !== 'Home')
              .map(({ path, label, sub }, idx) => (
                <li key={idx}>
                  <Button to={path} type="link" size="">
                    { label }
                  </Button>

                  { 
                    sub?.length > 0 && (
                      <ul className="pl-8">
                        {
                          sub.map((subRoute, jdx) => (
                            <li key={`sub-route-${jdx}`}>
                              <Button to={subRoute.path} type="link" size="">
                                { subRoute.label }
                              </Button>
                            </li>
                          ))
                        }
                      </ul>
                    )
                  }
                </li>
              ))
          }
          </ul>
        </section>
    </Container>
  )
}

export default Home